"use client";

import {
	AlignVerticalJustifyCenterIcon,
	AlignVerticalJustifyEndIcon,
	AlignVerticalJustifyStartIcon,
	ArrowLeftIcon,
	ArrowRightIcon,
} from "lucide-react";
import { useStoreBuilderContext } from "@/ui/admin/store-builder/store-builder-context";
import { CompactButtonGroup } from "../../shared/compact-button-group";
import type { YnsComponentForm } from "../types";
import type { FeatureSectionStoreBuilderConfigFactory } from "./config";

export const FeatureSectionForm: YnsComponentForm<typeof FeatureSectionStoreBuilderConfigFactory> = ({
	data,
}) => {
	const context = useStoreBuilderContext();

	const imagePositionOptions = [
		{ value: "left", icon: <ArrowLeftIcon className="size-3" />, tooltip: "Image on left" },
		{ value: "right", icon: <ArrowRightIcon className="size-3" />, tooltip: "Image on right" },
	];

	const imageSizeOptions = [
		{ value: "1/4", icon: <span className="text-xs">¼</span>, tooltip: "25%" },
		{ value: "1/3", icon: <span className="text-xs">⅓</span>, tooltip: "33%" },
		{ value: "1/2", icon: <span className="text-xs">½</span>, tooltip: "50%" },
	];

	const alignmentOptions = [
		{ value: "top", icon: <AlignVerticalJustifyStartIcon className="size-3" />, tooltip: "Top" },
		{ value: "middle", icon: <AlignVerticalJustifyCenterIcon className="size-3" />, tooltip: "Middle" },
		{ value: "bottom", icon: <AlignVerticalJustifyEndIcon className="size-3" />, tooltip: "Bottom" },
	];

	return (
		<div className="space-y-6">
			{/* Layout & Design Section */}
			<div>
				<div className="text-sm font-semibold text-neutral-900 mb-3 pb-2 border-b border-neutral-200">
					Layout & Design
				</div>
				<div className="space-y-4">
					<div className="grid grid-cols-2 gap-2">
						<div className="grid gap-1">
							<span className="text-xs text-neutral-600 font-medium">Image Position</span>
							<CompactButtonGroup
								options={imagePositionOptions}
								defaultValue={data?.image_position ?? "left"}
								onValueChange={(value) => {
									context.saveSelectedPageSectionField({
										fieldPath: "image_position",
										value,
									});
								}}
								className="w-full"
							/>
						</div>
						<div className="grid gap-1">
							<span className="text-xs text-neutral-600 font-medium">Image Size</span>
							<CompactButtonGroup
								options={imageSizeOptions}
								defaultValue={data?.imageSize ?? "1/4"}
								onValueChange={(value) => {
									context.saveSelectedPageSectionField({
										fieldPath: "imageSize",
										value,
									});
								}}
								className="w-full"
							/>
						</div>
					</div>

					<div className="grid gap-1">
						<span className="text-xs text-neutral-600 font-medium">Alignment</span>
						<CompactButtonGroup
							options={alignmentOptions}
							defaultValue={data?.alignment ?? "top"}
							onValueChange={(value) => {
								context.saveSelectedPageSectionField({
									fieldPath: "alignment",
									value,
								});
							}}
							className="w-full"
						/>
					</div>
				</div>
			</div>
		</div>
	);
};
